module.exports = __webpack_public_path__ + "img/head.d4471c79.jpg";